<template>
    <div class="overlay-back" v-show="sideMenuOpened">
        <div class="side-menu">

            <div class="x-icon icon close" v-on:click="closeSideMenu()"></div>

            <div class="language-wrapper">
                <Language></Language>
            </div>
            <div class="menu-wrapper">
                <ul>
                    <li @click="openVerifyVignetteModal">{{ $t('check_vignette_valability') }}</li>
                    <li class="resurse has-subpages" @click="displaySubpages()">
                        <div>{{ $t('resources') }}</div>
                        <ul v-if="displayedSubPages">
                            <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'how-it-works'}">{{ $t('how_it_works') }}</router-link></li>
                            <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'questions'}">{{ $t('faq_title') }}</router-link></li>
                            <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'info'}">{{ $t('info') }}</router-link></li>
                        </ul>
                    </li>
                    <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'about-us'}">{{ $t('about') }} {{ $t('us') }}</router-link></li>
                    <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'company-advanges'}"> {{ $t('for_companies') }}</router-link></li>
                    <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'distribution'}">{{ $t('distribution_untrr') }}</router-link></li>
                    <li><router-link v-on:click.native="closeSideMenu()" :to="{name: 'contact'}">{{ $t('contact_title') }}</router-link></li>
                </ul>
                <router-link :to="{name: 'vignette'}" v-on:click.native="closeSideMenu()" class="d-flex justify-content-end">
                    <button type="button" class="btn btn-lg btn-purple" :class="isMobile() ? 'w-100' : 'mr-2'">{{ $t('i_want_vignette') }}</button>
                </router-link>
                <router-link :to="{name: 'toll'}" v-on:click.native="closeSideMenu()" class="d-flex justify-content-end">
                    <button type="button" class="btn btn-lg btn-purple" :class="isMobile() ? 'w-100' : 'ml-2'">{{ $t('i_want_toll') }}</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import FooterMobile from './../FooterMobile.vue'
import Language from '../snippets/Language.vue';

export default {
    name: 'SideMenu',
    data: function() {
        return {
            displayedSubPages: false,
        };
    },
    components: {
        FooterMobile,
        Language
    },
    props: {
    },
    computed: {
        ...mapGetters('menu', [
            'sideMenuOpened'
        ]),
    },
    mounted: function() {
    },
    methods: {

        ...mapActions('menu', [
            'toogleSideMenu'
        ]),

        ...mapActions('menu', [
            'closeSideMenu'
        ]),

        open() {
            this.toogleSideMenu();
        },

        displaySubpages() {
            this.displayedSubPages = !this.displayedSubPages;
            $('.has-subpages').toggleClass('opened');
        },

        openVerifyVignetteModal() {
            this.$eventBus.$emit('openVerifyVignette');
        }
    },
    watch: {
        '$route' (to, from) {
            this.closeSideMenu();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$accent-color: #3F24E2;

.side-menu {
    position: absolute;
    width: 95%;
    height: 100%;

    background: #FAF9F6;
    z-index: 3500;
    overflow-y: auto;
    right: 0;
    a {
        color: #000;
    }

    .in {
        padding: 25px;
    }

    .close {
        font-size: 24px;
        margin: 20px;
        right: 0;
        top: 0;
    }
    .language-wrapper {
        margin-top: 55px;
        margin-bottom: 20px;
    }
    .menu-wrapper {
        ul>li {
            padding: 20px;
            border-bottom: 1px solid #CBC9C6;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            &.has-subpages {
                &.opened {
                    div:after {
                        content: url('../../media/icons/arrow_opened.svg');
                    }
                }
                div:after {
                    content: url('../../media/icons/arrow.svg');
                    position: absolute;
                    color: black;
                    right: 15px;
                    height: 20px;
                    width: 20px;
                }
                ul {
                    padding-left: 10px;
                    > li {
                        border: 0;
                        border-top: 0;
                        padding: 10px;
                        &:first-of-type {
                            padding-top: 15px;
                        }
                        &:last-of-type {
                            margin: 0;
                            padding-bottom: 0;
                        }
                    }
                }
            }
        }
        ul>li:first-of-type {
            border-top: 1px solid #CBC9C6;
        }
        ul>li:last-of-type {
            margin-bottom: 30px;
        }
        a {
            text-decoration: none;
            &:hover {
                text-decoration: none;
            }
            .btn-purple {
                font-size: 18px;
                margin: 0 20px 20px 20px;
                text-align: center;
            }
        }
    }
}
</style>
